/*
 * Конфиг приложения — из переменных `VITE_*` на момент сборки (`.env.<режим>`).
 * Загрузки `/config.json` во время выполнения больше нет: файл никто не
 * заполнял, а в образе он отдавался всем по публичному адресу.
 */

export interface AppConfig {
  API_URL: string
  AUTH_API_URL: string
  TEST_MODE: boolean // `VITE_TEST_MODE`: тестовый вход и метка в футере, только в dev
}

const DEFAULT_CONFIG: AppConfig = {
  API_URL: import.meta.env.VITE_API_URL,
  AUTH_API_URL: import.meta.env.VITE_AUTH_API_URL,
  TEST_MODE: import.meta.env.VITE_TEST_MODE === 'true',
}

let config: AppConfig = DEFAULT_CONFIG
let isLoaded = false

export async function loadConfig(): Promise<AppConfig> {
  if (isLoaded) return config

  /*
   * БЕЗ ЖУРНАЛА В КОНСОЛЬ. Здесь печатался весь конфиг при каждой загрузке,
   * в проде тоже: адреса сервисов и строка «TEST_MODE: ENABLED
   * (secret-dreamlab)», подсказывающая, что тестовый вход существует. Куда
   * смотрит сборка, видно на экране «Системные настройки».
   */
  config = { ...DEFAULT_CONFIG }
  isLoaded = true
  return config
}

// Синхронный геттер (использовать после loadConfig)
export function getConfig(): AppConfig {
  return config
}

// Отдельные геттеры для удобства
export function getAuthApiUrl(): string {
  return config.AUTH_API_URL
}

export function isTestMode(): boolean {
  return config.TEST_MODE
}
